export class Widget
{
    constructor({
        parent,  // another Widget
        parentNode, // a DOM node
        html,
        signal,
    })
    {
        this._abortController = new AbortController();
        this._signal = this._abortController.signal;
        this._signal.addEventListener("abort", () => console.log("Widget aborted"));

        if(parentNode && !parent)
            parent = Widget.findContainingWidget(parentNode);

        this._parent = parent;
        this._parentNode = parentNode;

        // Shut down if signal is aborted.  If we weren't given one and we have a
        // parent widget, shut down if it does.
        if(signal == null && this._parentNode)
            signal = this._parentNode._signal;
        
        if(signal)
            signal.addEventListener("abort", () => this._abortController.abort());

        let template = document.createElement("template");
        template.innerHTML = html;
        this.root = document.importNode(template.content, true).firstElementChild;
        parentNode.appendChild(this.root);

        this.root.widget = this;
    }

    static findContainingWidget(node)
    {
        while(node)
        {
            if(node.widget)
                return node.widget;
            node = node.parentNode;
        }
        return null;
    }

    shutdown()
    {
        this._abortController.abort();
        this.root.remove();
    }
}
